import { useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { useClients } from '../contexts/ClientsContext';

export function useSupabaseClients() {
  const { clients, setClients } = useClients() as any;

  useEffect(() => {
    if (!supabase) return;

    // Fetch clients from Supabase
    const fetchClients = async () => {
      const { data, error } = await supabase
        .from('clients')
        .select('*')
        .order('name', { ascending: true });

      if (error) {
        console.error('Error fetching clients:', error);
        return;
      }

      if (data) {
        const formattedClients = data.map((c: any) => ({
          id: c.id,
          name: c.name,
          email: c.email,
          phone: c.phone,
          createdAt: c.created_at,
        }));
        
        // Update local state
        if (typeof setClients === 'function') {
          setClients(formattedClients);
        }
      }
    };

    fetchClients();

    // Subscribe to changes
    const subscription = supabase
      .channel('clients-changes')
      .on('postgres_changes', { event: '*', schema: 'public', table: 'clients' }, () => {
        fetchClients();
      })
      .subscribe();

    return () => {
      subscription.unsubscribe();
    };
  }, [setClients]);
}





